import { getSite } from '../../../provolution/jsCore/application/pageDataObject'

function getCookie(name) {
  let re = new RegExp(name + '=([^;]+)')
  let value = re.exec(document.cookie)
  return value !== null ? unescape(value[1]) : null
}

export function trackUserIdentifier() {
  const identifierFromStorege =
    localStorage.getItem('mmUserIdentifier') || Math.floor(Math.random() * 100)
  localStorage.setItem('mmUserIdentifier', identifierFromStorege)
  return identifierFromStorege
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/googleAnalyticaSessionTracker/useridentifierTracker.js